import {
  Component,
  ViewChild,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ReplaceFonts, ReplaceFontType } from 'src/app/supporting/replaceFont';
import { LanguageManagementService } from 'src/service/language-management.service';
import {
  FocusInputType,
  KeyValues15,
  KeyValueSet,
  KeyValueSets,
  LocalService,
  NumericConfig,
  PrintHtml,
  QrLabelTemplateType,
  QrLabelVariableType,
  Status,
  TriggeredEvent,
} from 'src/service/local.service';
import { QrlabelService } from 'src/service/qrlabel.service';
import { SellerManagementService } from 'src/service/seller-management.service';

@Component({
  selector: 'app-qr-label-preview-settings',
  templateUrl: './qr-label-preview-settings.component.html',
  styleUrl: './qr-label-preview-settings.component.scss',
})
export class QrLabelPreviewSettingsComponent {
  QrLabelTemplateType = QrLabelTemplateType;
  @ViewChild('content_label_preview_settings')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();
  @Output() onHtmlGenerated = new EventEmitter();

  lstSectionConfigKeys: string[] = ['qr_label_gen'];

  numericConfig: NumericConfig = { isDecimalAllowed: true } as NumericConfig;
  numericConfigWithoutDecimal: NumericConfig = {
    isDecimalAllowed: false,
  } as NumericConfig;

  @Input() countryCode: string = '';
  @Input() businessId: string = '';
  @Input() templateFor: QrLabelTemplateType = QrLabelTemplateType.None;
  @Input() isSample: boolean = false;
  @Input() selectedTemplateId: string = '';
  @Input() filterData: any;
  @Input() selectedUploaId: string = '';
  @Input() isUploadedData: boolean = false;
  @Input() isSinglePrint: boolean = true;

  htmlId: string = '';
  elementIds: any;
  item: KeyValues15;
  templates: KeyValueSet[];
  expectedBusinessTypes: KeyValueSet[];

  constructor(
    private offcanvasService: NgbOffcanvas,
    public localService: LocalService,
    private languageManagementService: LanguageManagementService,
    private qrlabelService: QrlabelService,
    private sellerManagementService: SellerManagementService,
  ) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      template: 'template_' + this.htmlId,
      copies: 'copies_' + this.htmlId,
      lbl_per_row: 'lbl_per_row_' + this.htmlId,
      start_column: 'start_column_' + this.htmlId,
      paper_margin: 'paper_margin_' + this.htmlId,
      template_margin: 'template_margin_' + this.htmlId,
      width: 'width_' + this.htmlId,
      height: 'height_' + this.htmlId,
      template_radius: 'template_radius_' + this.htmlId,
      termplate_border_radius: 'termplate_border_radius_' + this.htmlId,
      generate: 'generate_' + this.htmlId,
      business_type: 'business_type_' + this.htmlId,
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(
      this.lstSectionConfigKeys,
    );
    this.onInitiate();
  }

  onInitiate() {
    this.onGetExpectedBusiness();

    this.qrlabelService
      .getQrLabelTemplatesToDisplay(
        this.localService.getLoginAsCountryCode(),
        this.businessId,
        this.templateFor,
      )
      .subscribe((result) => {
        this.templates = result;
        this.onCheckDefaultExpectedBusinessTypes();
      });
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss,
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.qrlabelService
      .getQrLabelPrintLastSetting(
        this.localService.getLoginAsCountryCode(),
        this.businessId,
        this.templateFor,
      )
      .subscribe((result) => {
        this.item = result;
        if (this.selectedTemplateId && this.selectedTemplateId.length > 5) {
          this.item.v3 = this.selectedTemplateId;
        }
        this.isSinglePrint = this.item.v14 == '1';
        this.onCheckDefaultExpectedBusinessTypes();
        this.localService.onFocusNextInput(
          this.elementIds.title,
          FocusInputType.TextBox,
        );
      });
  }

  onAction(index: number) {
    switch (index) {
      case 1:
        {
          this.onGenerateLabelHtml();
        }
        break;
    }
  }

  onGetExpectedBusiness() {
    this.expectedBusinessTypes = [];
    this.sellerManagementService
      .getExpectedBusinessTypes(
        this.localService.getLoginAsCountryCode(),
        this.businessId,
      )
      .subscribe((result) => {
        result.forEach((res) => {
          this.expectedBusinessTypes.push({
            key: res,
            value: this.localService.getText(
              this.localService.businessTypes,
              res,
            ),
          } as KeyValueSet);
          this.onCheckDefaultExpectedBusinessTypes();
        });
      });
  }

  onCheckDefaultExpectedBusinessTypes() {
    if (
      this.item &&
      this.templates.length > 0 &&
      this.expectedBusinessTypes.length > 0 &&
      (!this.item.v13 || this.item.v13 == '0') &&
      this.templateFor == QrLabelTemplateType.Product
    ) {
      this.item.v13 = this.expectedBusinessTypes[0].key;
    }
  }

  onGenerateLabelHtml() {
    this.item.v14 = this.isSinglePrint ? '1' : '0';
    this.qrlabelService
      .getLabelHtml(
        this.businessId,
        this.templateFor,
        this.item,
        this.filterData,
        this.isSample,
        this.selectedUploaId,
      )
      .subscribe((result) => {
        if (result) {
          if (result.status == Status.NotFound) {
            this.localService.showInformation(
              this.localService.languageContent.qr_label_gen
                .variables_not_found,
              true,
              3,
            );
          } else {
            this.localService.showInformationByStatus(result.status);

            if (result.status == Status.Success) {
              const html = ReplaceFonts(result.value, ReplaceFontType.FontName);
              const data = {
                html: html,
                values: result.values,
                isSinglePrint: this.isSinglePrint,
              } as PrintHtml;
              this.onHtmlGenerated.emit(data);
              this.onCloseTrigger();
            }
          }
        }
      });
  }
}
